import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const CustomizedSwal = withReactContent(Swal);

export const onDisplayAlert = ({
  title,
  description,
  html,
  type,
  preConfirm,
  showCancelButton,
  confirmButtonText,
  cancelButtonText,
  customClass,
}) => {
  const options = {
    title: <strong>{title}</strong>,
    html: html || description,
    icon: type,
    preConfirm,
  };
  // SweetAlert2 merges options with its defaults via Object.assign, so an explicit
  // `undefined` here would overwrite defaults like confirmButtonText: 'OK'. Only set
  // these when a caller actually provides them.
  if (showCancelButton !== undefined) options.showCancelButton = showCancelButton;
  if (confirmButtonText !== undefined) options.confirmButtonText = confirmButtonText;
  if (cancelButtonText !== undefined) options.cancelButtonText = cancelButtonText;
  if (customClass !== undefined) options.customClass = customClass;
  return CustomizedSwal.fire(options);
};
